//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import FormWrap from './FormAside/FormWrap'
  import InputFile from './FormAside/InputFile'
  import MtInput from "../../components/form/MtInput";
  import MtCheckbox from "../../components/form/MtCheckbox";
  import Button from "../../components/other/Button";
  export default {
    components: {
      FormWrap
    },
    data() {
      return {
        policyChecked: false,
        inputValues: {
          name:'',
          email: '',
          phone: '',
          message: '',
          file:{}
        }
      }
    },
    computed:{
      hasMessage () {
        return !!this.inputValues.message
      },
      isEn () {
        return this.$i18n.locale === 'en'
      },
      getForm() {
        const url = this.isEn ? 'https://crm.tretyakov.ru/upload/crm/form/loader_157_jlf50m.js' : 'https://crm.tretyakov.ru/upload/crm/form/loader_74_req9jy.js'
        return `(function(w,d,u){
		var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);
		var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
	})(window,document,'${url}');`
      }
    },
    beforeDestroy () {
      if (window && window.b24form && window.b24form.forms) {
        window.b24form.forms = null
      }
    },
    methods: {
      handleFileChange(e) {
        e.target.files[0].field = e.target.name;
        this.inputValues.file = e.target.files[0]
      },
      clearFile() {
        this.inputValues.file = {}
        this.$refs.upload.$refs.fileupload.value = null;
      }
    }
  }
